module.exports = __webpack_public_path__ + "img/6-iBillete.b5fc18d6.jpg";